import {
  ApproveModalPayload,
  ApproveRejectModalPayload,
  BridgeModalPayload,
  CommerceModalPayload,
  CratNewModalPayload,
  CratSwapModalPayload,
  DelegatorModalPayload,
  ExplorerModalPayload,
  IntellectualPropertyModalPayload,
  LiteBackerModalPayload,
  LuxuryLifestyleModalPayload,
  PaymentGatewayModalPayload,
  RealEstateModalPayload,
  SeavProtocolModalPayload,
  SendModalPayload,
  SendRejectModalPayload,
  SendSuccessModalPayload,
  SendTimeoutModalPayload,
  SmartSwapModalPayload,
  StakingModalPayload,
  Tap2MineModalPayload,
  TurboBackerModalPayload,
  ValidatorModalPayload,
} from '../ui';

export enum ModalType {
  // circle
  Commerce = 'Commerce',
  LuxuryLifestyle = 'LuxuryLifestyle',
  PaymentGateway = 'PaymentGateway',
  Explorer = 'Explorer',
  SEAV = 'SEAV',
  Staking = 'Staking',
  IntellectualProperty = 'IntellectualProperty',
  RealEstate = 'RealEstate',
  CratSwap = 'CratSwap',
  SmartSwap = 'SmartSwap',
  Bridge = 'Bridge',
  Tap2Mine = 'Tap2Mine',

  CratNew = 'CratNew',
  Delegator = 'Delegator',
  Validator = 'Validator',
  LiteBacker = 'LiteBacker',
  TurboBacker = 'TurboBacker',
  Approve = 'Approve',
  ApproveReject = 'ApproveReject',
  Send = 'Send',
  SendReject = 'SendReject',
  SendSuccess = 'SendSuccess',
  SendTimeout = 'SendTimeout',
}

export interface IModal<T extends { type: ModalType; data: any } = { type: ModalType; data: any }> {
  onClose: () => void;
  data: T['data'];
  isOpen?: boolean;
}
export type IModalPayload =
  | CommerceModalPayload
  | LuxuryLifestyleModalPayload
  | PaymentGatewayModalPayload
  | ExplorerModalPayload
  | SeavProtocolModalPayload
  | StakingModalPayload
  | IntellectualPropertyModalPayload
  | RealEstateModalPayload
  | CratSwapModalPayload
  | SmartSwapModalPayload
  | BridgeModalPayload
  | Tap2MineModalPayload
  | CratNewModalPayload
  | DelegatorModalPayload
  | ValidatorModalPayload
  | LiteBackerModalPayload
  | TurboBackerModalPayload
  | ApproveModalPayload
  | ApproveRejectModalPayload
  | SendModalPayload
  | SendRejectModalPayload
  | SendSuccessModalPayload
  | SendTimeoutModalPayload;

export type ModalTransition = 'fade' | 'slide';
